module.exports = __webpack_public_path__ + "static/media/integration.3c66be10.png";